import React from 'react';
import { Link } from 'react-router-dom';
import '../components/footer.css';
import { FaFacebookF, FaInstagram, FaXTwitter } from 'react-icons/fa6';

export default function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-left">© SCREEN TO SCENE 2025</div>

      <div className="footer-center">
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://x.com" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
        </div>
      </div>

      <div className="footer-right">
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/settings">Settings</Link>
      </div>
    </footer>
  );
}
